import { AUDIO_QUALITY_CONFIDENCE_THRESHOLD } from '@/constants/transcription'

export const AUDIO_QUALITY_NUDGE_STORAGE_PREFIX = 'audioQualityNudge.dismissed.' as const

export function getAudioQualityNudgeStorageKey(artifactId: string): string {
	return `${AUDIO_QUALITY_NUDGE_STORAGE_PREFIX}${artifactId}`
}

export function readDismissedFromLocalStorage(artifactId: string): boolean {
	if (typeof window === 'undefined') return false
	try {
		const key = getAudioQualityNudgeStorageKey(artifactId)
		return window.localStorage.getItem(key) != null
	} catch {
		return false
	}
}

export function writeDismissedToLocalStorage(artifactId: string): boolean {
	if (typeof window === 'undefined') return false
	try {
		const key = getAudioQualityNudgeStorageKey(artifactId)
		window.localStorage.setItem(key, '1')
		return true
	} catch {
		return false
	}
}

export function shouldShowLowConfidenceNudge(
	confidence: number | null | undefined,
	threshold: number = AUDIO_QUALITY_CONFIDENCE_THRESHOLD
): boolean {
	if (confidence == null || Number.isNaN(confidence)) {
		return false
	}
	return confidence < threshold
}
